var map = {
	"./18PW.png": 54852,
	"./19PW.png": 81980,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusBronze/18PW.png": 54852,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusBronze/19PW.png": 81980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48835;